module.exports = __webpack_public_path__ + "img/game_verification_2_es.ca305fec.png";